import { render, staticRenderFns } from "./AnnouncePopup.vue?vue&type=template&id=12d633ce&scoped=true&"
import script from "./AnnouncePopup.vue?vue&type=script&lang=js&"
export * from "./AnnouncePopup.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncePopup.vue?vue&type=style&index=0&id=12d633ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d633ce",
  null
  
)

export default component.exports